import { render, staticRenderFns } from "./AddInspectDialog.vue?vue&type=template&id=60d15238&scoped=true"
import script from "./AddInspectDialog.vue?vue&type=script&lang=js"
export * from "./AddInspectDialog.vue?vue&type=script&lang=js"
import style0 from "./AddInspectDialog.vue?vue&type=style&index=0&id=60d15238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d15238",
  null
  
)

export default component.exports